export const font = {
    ambitThin: 'Ambit-Thin',
    ambitExtraLight: 'Ambit-ExtraLight',
    ambitLight: 'Ambit-Light',
    ambitRegular: 'Ambit-Regular',
    ambitSemiBold: 'Ambit-SemiBold',
    ambitBold: 'Ambit-Bold',
    ambitBlack: 'Ambit-Black',
};
